import { GlobalStyles as GlobalThemeStyles } from '@mui/material';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import useCssReset from './useCssReset';
import useCssSpecialClasses from './useCssClasses';
import useMaterialIcons from './useMaterialIcons';
import useMuiComponentsOverrides from './useMuiComponentsOverrides';

const GlobalStyles = () => {
  const { cssReset } = useCssReset();
  const { cssSpecialClasses } = useCssSpecialClasses();
  const { materialIcons } = useMaterialIcons();
  const { muiComponentsOverrides } = useMuiComponentsOverrides();

  return (
    <GlobalThemeStyles
      styles={{
        ...cssReset,

        ...cssSpecialClasses,

        ...materialIcons,

        ...muiComponentsOverrides
      }}
    />
  );
};

export default GlobalStyles;
